var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"header-background"},[_c('v-img',{attrs:{"height":"650","src":"/header-bg.webp"}},[_c('div',{staticClass:"title-wrap"},[_c('div',{ref:"sloganAnimate",staticClass:"section-title"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }